import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: auto; // Changed from fixed height to auto
  min-height: 100vh; // Ensure minimum height of viewport
  overflow: hidden;
  margin-top: 16rem;
  margin-bottom: 16rem;
  background: black;
  padding-bottom: 2rem; // Added padding to ensure content isn't cut

  @media (max-width: 768px) {
    min-height: 100vh; // Use min-height instead of fixed height
    margin-top: 8rem;
    margin-bottom: 8rem;
  }
`;

const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.8;
  z-index: 1; // Ensure video stays behind content
`;

const ContentOverlay = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: white;
  width: 100%;
`;

const ContentContainer = styled.div`
  width: 100%;
  padding: 4rem 50px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1.5rem 0;
  }
`;

const MainHeadline = styled.h2`
  color: #49abdb;
  font-size: 4.5rem;
  font-weight: bold;
  margin-bottom: 4rem;
  line-height: 1.2;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    padding: 0 20px;
  }
`;

const TextColumn = styled.div`
  width: 40%;

  @media (max-width: 768px) {
    width: 100%;
    background: black;
    padding: 1rem 20px;
    box-sizing: border-box;
  }
`;

const BodyParagraph = styled.p`
  color: #d69de6;
  font-size: 1.3rem;
  line-height: 1.5;
  margin-bottom: 0.8rem;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const ScienceCaresSection = styled.div`
  color: #d69de6;
  font-size: 1.3rem;
  margin-top: 4rem;
  text-align: left;

  @media (max-width: 768px) {
    margin-top: 1.5rem;
  }
`;

const ScienceCares = styled.p`
  color: white;
  font-weight: bold;
`;

const CommunicationSection = () => {
  return (
    <SectionWrapper>
      <VideoBackground 
        autoPlay 
        muted 
        loop 
        playsInline
      >
        <source src="/videos/vertical.mp4" type="video/mp4" />
      </VideoBackground>

      <ContentOverlay>
        <ContentContainer>
          <MainHeadline>
            WE ARE MEDICINE<br/>
            THROUGH COMMUNICATION
          </MainHeadline>

          <TextColumn>
            <BodyParagraph>
              HEARTPORT brings scientific knowledge to where it can make a difference, into clinical practice, prevention and people's everyday lives.
            </BodyParagraph>
            <BodyParagraph>
              Through our digital platforms, scientific initiatives and conferences, we connect research with those who can use it: doctors, scientists, patients and the public.
            </BodyParagraph>

            <ScienceCaresSection>
              <p>Because,</p>
              <ScienceCares>SCIENCE CARES</ScienceCares>
            </ScienceCaresSection>
          </TextColumn>
        </ContentContainer>
      </ContentOverlay>
    </SectionWrapper>
  );
};

export default CommunicationSection;
